import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { commonClass } from '../../helpers/commonClass';
import { history } from '../../helpers/history';
import { gameActions } from '../../action/GameAction';

class ViewAvailBonus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            MoreinfoFlag: false,
            bonus_id: ""
        }
        if (!this.props.Availbonus || this.props.Availbonus.length <= 0) {
            // 1 - register,2 - wallet
            this.props.ShowAvailableBonus(this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey, this.props.filtertype);
        }
        this.props.getbonusperuser(this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey)
    }


    static getDerivedStateFromProps(props, state) {
        return {
            Availbonus: props.Availbonus,
            bonus_details: props.bonus_details
        };
    };

    Moreinfo = (obj) => {
        // history.push('/bonus-details');
        this.setState({ MoreinfoFlag: true })
        if (window.LoginOverlay) {
            setTimeout(() => {
                window.LoginOverlay()
            }, 100);
        }
        this.setState({ bonus_id: obj })
    }

    ApplyBonus = (Obj) => {
        this.props.getbonus(Obj);
        this.props.ChangeComponent(true)
    }

    capitalizeFirstLetter = (str) => {
        if (!str) return ""; // handle empty string
        return str.charAt(0).toUpperCase() + str.slice(1);
    }


    render() {
        const { t } = this.props;
        return (
            <>
                <div class="myAccContHead">
                    <h1><img src="./assets/img/icons/tabs-wallet.png" />Available Bonus</h1>
                    <a onClick={() => { this.props.ChangeComponent(true) }}>{t('lblBack')}</a>
                </div>
                {this.props.Availbonus && this.props.Availbonus.length > 0 ?
                    <div class="bonuscontsiner">
                        <ul>
                            {this.props.Availbonus && this.props.Availbonus.length > 0 && this.props.Availbonus.map((x1, inx1) =>
                                <li>
                                    <div className="row">
                                        <div class="bonusLeft"><span>{x1.bonus_name}</span></div>
                                        <div class="bonusRight">
                                            <button class="bonusBtnWt" onClick={() => { this.Moreinfo(x1.bonus_id) }}>{t('lblmoredetails')}</button>
                                            {/* <a href={`${commonClass.setUrl()}/bonus-details-separate?bonus_id=${x1.bonus_id}`} target="_blank" rel="noopener" >{t('lblmoredetails')}</a> */}
                                            <button class="bonusBtnOg" onClick={() => { this.ApplyBonus(x1) }}>{t('lblapply')}</button>
                                        </div>
                                        {/* <div onClick={() => { this.ApplyBonus(x1) }}><button className='styled-button'>{t('lblapply')}</button></div> */}
                                    </div>
                                </li>
                            )}
                        </ul>
                    </div>
                    :
                    <>
                        <div class="noOrders">
                            <img src="./assets/img/icons/sad.png" />
                            <h3>{t("lblNoAvailableBonus")}</h3>
                            <p class="margin-bottom-20">{t("lblAvailableBonusEmpty")}</p>
                            <div class="formCont updateBtn">
                                <button onClick={() => { this.props.ChangeComponent(true) }}>{t('lblback')} {t('lblAddMoney')}</button>
                            </div>
                        </div>
                    </>
                }

                {this.state.MoreinfoFlag &&
                    <>
                        <div class="ticketBox" id='ticketBox' style={{ display: "block" }}>
                            <div class="ticketBoxWrap">
                                {/*  onClick={() => { this.setState({ MoreinfoFlag: false }) }}  */}
                                <a class="lightBoxClose" id='lightBoxClose'><img src="./assets/img/icons/pop_close.png" /></a>
                                <div class="depositPop">
                                    {this.state.bonus_details && this.state.bonus_details.array && this.state.bonus_details.array.length > 0 && this.state.bonus_details.array.filter(a => this.state.bonus_id == 0 || this.state.bonus_id == a.bonus_id).map((item, inx1) =>
                                        <>
                                            {/* <h2>01<sup>St</sup> Deposit</h2> */}
                                            <h2>{inx1 + 1}. {item.bonus_name}</h2>
                                            <ul>
                                                {Object.keys(item).map((key) => (
                                                    <>
                                                        {key != 'bonus_name' && key != 'bonus_id' &&
                                                            <li>
                                                                <div class="w-20"><span class="ft">{this.capitalizeFirstLetter(key.replaceAll("_", " "))}:</span></div>
                                                                <div class="w-60"><span>{item[key]}</span></div>
                                                            </li>
                                                        }
                                                    </>
                                                ))}
                                            </ul>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div class="overlayLogin lightBoxClose" style={{ display: "block" }}></div>
                    </>
                }
            </>
        );
    }
}

function mapStateToProps(state) {
    const { user, appvariables } = state.loginReducer;
    const { Availbonus, bonus_details } = state.gameReducer;
    return { user, appvariables, Availbonus, bonus_details };
}
const mapActionToProps = {
    ShowAvailableBonus: gameActions.ShowAvailableBonus,
    getbonusperuser: gameActions.getbonusperuser
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(ViewAvailBonus))